import { RootState } from 'src/types';

export const contentfulSelector = (state: RootState) => state?.contentful?.contentful;